import { inject, Injectable } from '@angular/core';
import { AuthService } from '@app/shared/services/auth.service';

export const TIME_REPORT_ADMIN_EMAIL = 'PIOTR@PROFFEO.NET';

/**
 * TimeReportsActionsService - Canonical permission rules for time-report operations.
 *
 * Scope: Global (`providedIn: 'root'`).
 *
 * Usage: Used by report dialogs and report actions that gate creating or managing reports
 * on behalf of another user.
 *
 * Architecture:
 * - {@link TimeReportsActionsService}: User-facing permission checks
 * - {@link AuthService}: Current signed-in user
 * - {@link TimeReportsDataService}: Time-report data access and mutations
 */
@Injectable({ providedIn: 'root' })
export class TimeReportsActionsService {
  private readonly authService = inject(AuthService);

  public isTimeReportAdmin(email: string | undefined): boolean {
    return email?.toUpperCase() === TIME_REPORT_ADMIN_EMAIL;
  }

  public canManageTimeReport(reportOwnerUserId: string | undefined): boolean {
    const currentUser = this.authService.currentUser();
    if (!currentUser) {
      return false;
    }

    return currentUser.id === reportOwnerUserId || this.isTimeReportAdmin(currentUser.email);
  }
}
